export default __webpack_public_path__ + "static/media/transpaleta3.3ab57666.jpg";